import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Dashboard from '@/components/dashboard/Dashboard'
import Cities from '@/components/cities/Cities'
import CMS from '@/components/cms/CMS'
import Instagram from '@/components/instagram/Instagram'
import Maps from '@/components/maps/Maps'
import Quiz from '@/components/quiz/Quiz'
import Settings from '@/components/settings/Settings'
import Update from '@/components/update/Update'
import Backend from "../Backend";
import EventBus from '@/EventBus';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {needsAuth: true}
    },
    {
      path: '/cities',
      name: 'Cities',
      component: Cities,
      meta: {needsAuth: true}
    },
    {
      path: '/maps',
      name: 'Maps',
      component: Maps,
      meta: {needsAuth: true}
    },
    {
      path: '/quiz',
      name: 'Quiz',
      component: Quiz,
      meta: {needsAuth: true}
    },
    {
      path: '/cms',
      name: 'CMS',
      component: CMS,
      meta: {needsAuth: true}
    },
    {
      path: '/instagram',
      name: 'Instagram',
      component: Instagram,
      meta: {needsAuth: true}
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      meta: {needsAuth: true}
    },
    {
      path: '/update',
      name: 'Update',
      component: Update,
      meta: {needsAuth: true}
    },
    {
      path: '*',
      name: '404',
      component: Login
    }
  ]
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');

  if (to.meta.needsAuth) {
    if (!token) {
      next('/');
      return;
    }

    if (token && !Backend.instance.loggedIn) {
      Backend.instance.checkToken(token)
        .then(() => {
          console.log('token valid');

        })
        .catch((e) => {
          console.log('token invalid');
          localStorage.removeItem('token');
          next('/');
          return;
        });
    }
  }
  next();
});

EventBus.$on('authError', () => {
  router.push('Login');
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js